<template>
  <div class="bb-recommend text-center">
    <h5 class="recommend-guide__title">おすすめとは？</h5>
    <div class="bb-what pt-10">
      <div class="tile is-ancestor mb-40">
        <div v-for="(item, index) in items" :key="index" class="tile is-parent">
          <article class="tile is-child">
            <div :class="index !== 0 ? 'recommend_what_img' : ''">
              <img :src="item.img_url" />
            </div>
            <div class="c-text-primary fs-14 text-bold mt-10">{{ item.text }}</div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" src="../recommend.scss">
</style>

<script>
export default {
  name: 'RecommendWhat',
  components: {},
  data() {
    return {
      items: [
        {
          text: 'おすすめ商品をシェアして',
          img_url: require('@/assets/images/recommend/guide/what-flow-01.svg')
        },
        {
          text: 'おすすめから商品が購入されると',
          img_url: require('@/assets/images/recommend/guide/what-flow-02.svg')
        },
        {
          text: 'トークンを受け取れます！',
          img_url: require('@/assets/images/recommend/guide/what-flow-03.svg')
        }
      ]
    };
  }
};
</script>
